import React, { Component } from "react";
import {
  StyledAdvancedSectionHeader,
  StyledAdvancedSectionHeaderWithToggle,
  StyledColumnFlex,
} from "../styled/details/styleAdvancedPanel";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
import { Box, Flex } from "@chakra-ui/react";
import { isMobileView } from '@simplified-workspace/shared/util';

class TldrCollpasibleSection extends Component {
  toggleCollapse = () => {
    this.props.onToggleCollapse();
  };

  render() {
    const { title, toggleButton, collapse, subtitle } = this.props;
    return (
      <StyledColumnFlex>
        <StyledAdvancedSectionHeaderWithToggle>
          <StyledAdvancedSectionHeader onClick={this.toggleCollapse}>
            <Flex direction="row" align="center">
              {collapse ? <FaAngleRight /> : <FaAngleDown />}
              <Flex direction="column">
                <div>{title}</div>
                {subtitle && <div className="subtitle">{subtitle}</div>}
              </Flex>
            </Flex>
          </StyledAdvancedSectionHeader>
          {toggleButton}
        </StyledAdvancedSectionHeaderWithToggle>
        {!collapse && <Box mt={3}>{this.props.children}</Box>}
        <hr
          className={`tldr-hl mv-12 ${
            isMobileView() ? `border-transparent` : ``
          }`}
        />
      </StyledColumnFlex>
    );
  }
}

TldrCollpasibleSection.propTypes = {};
export default TldrCollpasibleSection;
